import 'forms/checkbox.less'
import 'forms/field.less'
import 'forms/input.less'
import 'forms/radio.less'
import 'forms/textarea.less'
import 'views/layout/button.less'

import {Checkbox, Form, Input, Radios} from '@codeurs/front'

import Textarea from 'forms/textarea'
import m from 'mithril'

export default class ContactForm extends Form {
	constructor({data = {}, ...config} = {}) {
		super({
			data: data,
			defaultRequired: false,
			...config
		})
	}

	textarea = config => this.fields.asField(Textarea, {...config})
	radio = config => this.fields.asField(Radios, config)
	checkbox = config => this.fields.asField(Checkbox, config)
	tel = config => this.fields.asField(Input, {...config, type: 'tel'})
	formSubmit = e => {
		e.preventDefault()
		const {data} = this.fields.store
		return m.request({
			method: 'POST',
			url: '/api/contact',
			data
		})
	}
}
